<div style="padding-left: 5px;padding-right: 3px; display:flex; align-self: flex-end;" (click)="$event.stopPropagation();" 
        (keyup.enter)="$event.stopPropagation();"  >
    <div mat-icon-button 
        #menuTrigger = "matMenuTrigger"
        [matMenuTriggerFor]="filterMenu" 
        [attr.ariaLabel]="columnName + ' Filter'" 
        id="columnName + 'FilterButton'"
        style="background-color: inherit; border: none;"
        tabindex="0" 
        (click)="filterInputFocus()"
        (keydown.enter)="openMenu($event)"
        (keydown.space)="openMenu($event)">
        
        <img alt="FilterIcon" *ngIf="!filtered" src="./assets/images/filter no circle 60 percent.png" 
                style="cursor:pointer;height:15px;width:15px;" />  
        <img alt="FilterIcon" *ngIf="filtered" src="./assets/images/filter no circle amber.png" 
                style="cursor:pointer;height:15px;width:15px;" />                   
    </div>
    <mat-menu #filterMenu="matMenu">
        <div class="menuContent" tabindex="0" aria-label="Filter Menu" >
            <filter-contents [dataType]="dataType" 
                #filterContents
                [data]="data" 
                [columnName]="columnName"
                [columnIndex]="columnIndex"
                (menuTrigger)="trigger.closeMenu()"
                [(dateValue)]="dateValue"
                [(filterValue)]="filterValue"
                [(operation)]="operation"
                (filterChange)="filterChange.emit($event)"
                [enumerationValues]="enumerationValues"
                [showTrueLabel]="showTrueLabel"
                [showFalseLabel]="showFalseLabel"
                [showIndeterminateLabel]="showIndeterminateLabel"
                [trueValue]="trueValue"
                [falseValue]="falseValue"
                [indeterminateValue]="indeterminateValue"
                (filterOperationChange)="filterOperationChange.emit($event)"
                (click)="$event.stopPropagation();"
                [debounceTime]="debounceTime"></filter-contents>
			<!-- NOTE: the click stopPropagation prevents a bug where the menu was being closed by clicking inside it -->
        </div>         
    </mat-menu>
</div> 
